import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { dateParse, timeParse } from 'Utils';
import { IconButton, Tooltip } from '@mui/material';
import ValidatorFormExted from 'components/ValidatorForm';
import EmployeesServices from 'services/EmployeesServices';
import EmployeeBranchesServices from 'services/EmployeeBranchesServices';
import { MuiTable, TableTopSearch, SingleViewDialog } from 'components';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { OfficerTypeDropDown, BranchDropDown, DepartmentDropDown, DesignationDropDown  } from 'AutoComplites';

const OfficersTab = ({ org }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [singleData, setSingleData] = React.useState(null);
  const [branchList, setBranchList] = React.useState([]);
  const [departmentList, setDepartmentList] = React.useState([]);
  const [officerData, setOfficerData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [officerType, setOfficerType] = React.useState(null);
  const [designation, setDesignation] = React.useState(null);
  const [branch, setBranch] = React.useState(null);
  const [department, setDepartment] = React.useState(null);
  const [filters, setFilters] = React.useState({
    page: 0, 
    limit: 10,
    search: ""
  });
  const [totalItems, setTotalItems] = React.useState(0);

  const handleView = async (row) => {
    setSingleData(row);
    try {
      const response = await EmployeeBranchesServices.get({ 
        employee_id: row.id, 
        designation: row.designation 
      });
      const data = response?.data?.view?.data || response?.data?.data || [];

      const branches = data.map(item => {
        const branch = item.branch_name || item.branch;
        if (typeof branch === 'object' && branch !== null) {
          return branch.name || '-';
        }
        return branch || '-';
      });
      
      const departments = data.map(item => {
        const dept = item.department_name || item.department;
        if (typeof dept === 'object' && dept !== null) {
          return dept.name || '-';
        }
        return dept || '-';
      });
      
      setBranchList(branches);
      setDepartmentList(departments);
    } catch (err) {
      setBranchList([]);
      setDepartmentList([]);
    }
    setOpenDialog(true);
  };

  const setPage = (page) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      page: page-1,
    }));
  };

  const setPageSize = (pageSize) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      page: 0,
      limit: pageSize,
    }));
  };

  React.useEffect(() => {
    if (!org?.id) return;
    setLoading(true);
    const fetchData = async () => {
      try {
        const params = {
          organization_id: org.id,
          status: 'Active',
          page: filters.page,
          limit: filters.limit,
        };
        
  
        if (filters.search && filters.search.trim()) {
          params.search = filters.search.trim();
    
          params.name = filters.search.trim();
        }
    
        if (officerType) {
          params.type = officerType;
        }
        if (designation) {
          params.designation_id = designation.id;
        }
        if (branch) {
          params.branch_id = branch.id;
        }
        if (department) {
          params.department_id = department.id;
        }

        console.log('API Params:', params); 

        const response = await EmployeesServices.get(params);
        
        const total = response?.data?.view?.totalItems || response?.data?.totalItems || 0;
        setTotalItems(total);
        const officers = response?.data?.view?.data || response?.data?.data || [];
        
        if (Array.isArray(officers)) {
          setOfficerData(officers.map((o, idx) => ({
            no: idx + 1 + filters.page * filters.limit, 
            name: o.name || '',
            officeType: o.type || o.office_type || '',
            designation: (o.designationDetails && o.designationDetails.name) ? o.designationDetails.name : (o.designation || ''),
            phone: o.contact_no || '',
            email: o.email || '',
            createdAt: o.createdAt,
            ...o
          })));
        } else {
          setOfficerData([]);
        }
      } catch (error) {
        setOfficerData([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [org?.id, filters.page, filters.limit, filters.search, officerType, designation, branch, department]);

  return (
    <>

        <ValidatorFormExted>
          <Grid container spacing={1}>
            <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
              <OfficerTypeDropDown
                label="Officer Type"
                value={officerType}
                onChange={(e, v) => setOfficerType(v)}
              />
            </Grid>
            <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
              <DesignationDropDown
              label="Designation"
                value={designation}
                onChange={(e, v) => setDesignation(v)}
                
              />
            </Grid>
            <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
              <BranchDropDown
              label="Branch"
                value={branch}
                onChange={(e, v) => setBranch(v)}
                filter={{ organization_id: org?.id }}
              />
            </Grid>
           <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
              <DepartmentDropDown
              label="Department"
                value={department}
                onChange={(e, v) => setDepartment(v)}
                filter={{ organization_id: org?.id }}
              />
            </Grid>
            <Grid container item size={{ xs:12, md:2}} sx={{ mt: { xs: 2, md: 3 } }}>
              <Grid item xs={6}>
                <Button 
                  variant="outlined" color="error"
                  onClick={() => {
                    setOfficerType(null);
                    setDesignation(null);
                    setBranch(null);
                    setDepartment(null);
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      page: 0,
                      search: ""
                    }));
                  }}
                >
                  <FilterAltOutlinedIcon />
                  Clear
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorFormExted>
  
        <TableTopSearch
          title='Officers'
          showSearch={true}
          showTotalWithTitle={true}
          rowCount={totalItems}
          onSubmitSearch={null}
          onSearchChange={(e) => {
            setFilters(prevData => ({
              ...prevData,
              search: e.target.value,
              page: 0
            }));
          }}
        />

      <MuiTable
        columns={[{
          accessorKey: 'name',
          header: 'Name',
        }, {
          accessorKey: 'officeType',
          header: 'Officer Type',
        }, {
          accessorKey: 'designation',
          header: 'Designation',
        }, {
          accessorKey: 'phone',
          header: 'Phone',
        }, {
          accessorKey: 'email',
          header: 'Email',
        }, {
          accessorKey: 'createDate',
          header: 'Create Date',
          Cell: ({ row }) => <span>{dateParse(row.original.createdAt)}</span>
        }, {
          accessorKey: 'createTime',
          header: 'Create Time',
          Cell: ({ row }) => <span>{timeParse(row.original.createdAt)}</span>
        }, {
          accessorKey: 'actions',
          header: 'Actions',
          Cell: ({ row }) => (
            <Tooltip title="View details">
              <IconButton size="small" color="primary" onClick={() => handleView(row.original)}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          ),
        }]}
        data={officerData}
        title="Officers"
        manualPagination={true}
        rowCount={totalItems}
        currentPage={filters.page } 
        pageSize={filters.limit}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        loading={loading}
      />

      <SingleViewDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        data={{
          title: singleData?.name,
          otherData: [
            {
              label: "Status",
              value: singleData?.status
            },
            {
              label: "Officer Type",
              value: singleData?.type || singleData?.office_type
            },
            {
              label: "Designation",
              value: singleData?.designationDetails?.name || singleData?.designation
            },
            {
              label: "Contact Number",
              value: singleData?.contact_no
            },
            {
              label: "Email",
              value: singleData?.email
            },
            {
              label: "Employee ID",
              value: singleData?.employee_id
            },
            {
              label: "NIC",
              value: singleData?.nic
            },
            {
              label: "Address",
              value: singleData?.address
            },
            
            {
              label: "Created At",
              value: singleData?.createdAt ? new Date(singleData.createdAt).toLocaleString() : ""
            },
            {
              label: "Updated At",
              value: singleData?.updatedAt ? new Date(singleData.updatedAt).toLocaleString() : ""
            },
            {
              label: "Branches",
              value: branchList.length > 0 ? branchList.join(', ') : '-'
            },
            {
              label: "Departments",
              value: departmentList.length > 0 ? departmentList.join(', ') : '-'
            },
          ]
        }}
      />
    </>
  );
};

export default OfficersTab;